var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormueLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.12 12.9369L118.13 0.977539H114.415L114.404 12.9369C114.404 14.7729 113.671 16.5336 112.366 17.8318C111.061 19.1301 109.29 19.8594 107.444 19.8594C105.598 19.8594 103.828 19.1301 102.523 17.8318C101.218 16.5336 100.484 14.7729 100.484 12.9369H100.485V0.977539H96.7704L96.7695 12.9369C96.7695 19.3689 102.158 23.6146 107.445 23.6169C112.635 23.6178 118.13 19.4698 118.12 12.9369Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8275 0.383789C27.5189 0.383789 25.2621 1.0647 23.3425 2.34043C21.4229 3.61615 19.9268 5.42938 19.0433 7.55084C18.1598 9.67229 17.9287 12.0067 18.3791 14.2588C18.8295 16.5109 19.9412 18.5796 21.5737 20.2033C23.2061 21.827 25.286 22.9327 27.5503 23.3807C29.8146 23.8287 32.1616 23.5988 34.2945 22.72C36.4274 21.8413 38.2505 20.3532 39.5331 18.444C40.8157 16.5347 41.5003 14.29 41.5003 11.9938C41.4969 8.91567 40.266 5.96461 38.0776 3.78805C35.8893 1.61149 32.9223 0.387204 29.8275 0.383789ZM37.7843 11.9938C37.7843 13.559 37.3177 15.0891 36.4434 16.3906C35.5691 17.692 34.3264 18.7064 32.8725 19.3054C31.4186 19.9044 29.8187 20.0611 28.2753 19.7557C26.7318 19.4504 25.314 18.6966 24.2013 17.5898C23.0885 16.483 22.3307 15.0729 22.0237 13.5377C21.7166 12.0026 21.8742 10.4113 22.4764 8.96523C23.0787 7.51914 24.0985 6.28314 25.407 5.41354C26.7155 4.54394 28.2538 4.07979 29.8275 4.07979C31.937 4.08217 33.9594 4.91669 35.4511 6.40027C36.9427 7.88385 37.7818 9.89535 37.7843 11.9935V11.9938Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9944 11.3848C63.9913 8.62563 62.8879 5.98031 60.9263 4.02924C58.9647 2.07817 56.3051 0.980676 53.531 0.977539V4.67324C55.3201 4.67514 57.0354 5.38286 58.3005 6.64111C59.5656 7.89936 60.2772 9.60537 60.2792 11.3848H63.9944Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0192 23.1827V19.4868C62.2303 19.4848 60.5151 18.7771 59.2501 17.5189C57.9851 16.2607 57.2735 14.5548 57.2715 12.7754H53.5549C53.558 15.5348 54.6616 18.1802 56.6233 20.1313C58.5851 22.0824 61.245 23.1798 64.0192 23.1827Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9249 12.7832H70.2092V23.1523H73.9249V12.7832Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9349 12.7832H87.2192V23.1523H90.9349V12.7832Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7792 0.977539H46.0635V23.1519H49.7792V0.977539Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.959961 23.1519H4.79689V4.70069L16.2323 4.67324V0.977539H0.959961V23.1519Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6827 10.2334H8.34644V13.9291H12.6827V10.2334Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M134.987 10.2334H130.651V13.9291H134.987V10.2334Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5478 14.5728L92.1684 3.01467L89.5411 0.401367L80.5478 9.34617L71.5547 0.401367L68.9272 3.01467L80.5478 14.5728Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.389 23.1519H138.54V19.4562L127.105 19.4287V4.70069L138.54 4.67324V0.977539H123.389V23.1519Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormueLogoFull);
export default __webpack_public_path__ + "static/media/formue-logo-full.2b81cb88d97f4c4591a08a161e81010f.svg";
export { ForwardRef as ReactComponent };